:host {
    --wcs-card-footer-gap: var(--wcs-semantic-spacing-base);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--wcs-card-footer-gap);
}
